module.exports = __webpack_public_path__ + "media/images/honeyfarm/farm_seven-5e5b6c8348a3d1176f765130b6f3a4ca.jpg";